import React, { useState } from "react";
import StandardModal from "./shared/StandardModal";
import Checkbox from "./shared/Checkbox";
import { PrimaryButton } from "./shared/button/PrimaryButton";
import { SecondaryButton } from "./shared/button/SecondaryButton";
import { useClassroomSessionStore } from "stores/v2/classroomSessionStore";

const OneActiveMonitorWarningModal = (props) => {
	const [suppressWarning, setSuppressWarning] = useState(false);
	const [starting, setStarting] = useState(false);

	const startSession = () => {
		localStorage.setItem("hideMonitoringSessionWarning", suppressWarning);
		setStarting(true);
		props.onStart(useClassroomSessionStore.getState().getSavedExpiry());
	};

	const renderActions = () => {
		return (
			<div>
				<SecondaryButton className="mui-flat-button" label="Cancel" onClick={props.onClose} />
				<PrimaryButton className="mui-flat-button" label="Continue" disabled={starting} onClick={startSession} />
			</div>
		);
	};

	return (
		<StandardModal size="medium" title="Heads up!" open={props.open} close={props.onClose} actions={renderActions()}>
			Only one monitoring class can be active at a time. Starting this session will stop your {props.existingClassname} session.
			<br />
			<br />
			<Checkbox checked={suppressWarning} onChecked={(isChecked) => setSuppressWarning(isChecked)} label="Don't show me this again" />
		</StandardModal>
	);
};

export default OneActiveMonitorWarningModal;
